import React from "react"
import { FormGroup, Col, ControlLabel, HelpBlock } from "react-bootstrap"

import { localized, localizedF } from "js/includes/common/utils"
import { whereEq } from "ramda"
import Select from "react-select"

const volumeOptions = [
  {
    value: "INCLUDE_ALL_VOLUMES",
    label: localizedF("editors.policy.actions.allVolumes"),
    checkList: "INCLUDE",
    volumeName: "ALL_VOLUMES",
  },
  {
    value: "INCLUDE_BOOT_VOLUME",
    label: localizedF("editors.policy.actions.bootVolume"),
    checkList: "INCLUDE",
    volumeName: "BOOT_VOLUME",
  },
  {
    value: "EXCLUDE_BOOT_VOLUME",
    label: localizedF("editors.policy.actions.excludingVolume"),
    checkList: "EXCLUDE",
    volumeName: "BOOT_VOLUME",
  },
  {
    value: "EXCLUDE_BOOT_AND_RECOVERY_VOLUMES",
    label: localizedF("editors.policy.actions.excludeRecovery"),
    checkList: "EXCLUDE",
    volumeName: "BOOT_AND_RECOVERY_VOLUMES",
  },
]

export default function DefragOption({ onChange, values: { volumeName, checkList }, validation }) {
  return (
    <FormGroup
      className="m-sm m-b-lg text-align-left"
      validationState={
        validation.success.volumeName === false || validation.success.checkList === false ? "error" : null
      }
    >
      <Col xs={4} componentClass={ControlLabel}>
        {localized("editors.policy.actions.parameters")}
      </Col>
      <Col xs={8}>
        <Select
          getOptionLabel={({ label }) => label()}
          options={volumeOptions}
          id="defragOptions"
          value={volumeOptions.find(whereEq({ volumeName, checkList }))}
          onChange={selection => {
            onChange({ volumeName: selection.volumeName, checkList: selection.checkList })
          }}
        />
        <HelpBlock className="invalid position-absolute m-t-none">
          {(validation.success.volumeName === false || validation.success.checkList === false) &&
            validation.message.volumeName}
        </HelpBlock>
      </Col>
    </FormGroup>
  )
}
